module.exports = __webpack_public_path__ + "img/flow.f94e0680.png";